<template>
  <users-filter></users-filter>
</template>

<script>
import store from "../../store/store";
import usersFilter from "./UsersFilter";
import {Mixin} from "/src/mixins/index.js";

export default {
  name: "UsersReport",
  mixins: [Mixin],
  components: {
    usersFilter
  },
  data() {
    return {};
  },

  methods: {},
  mounted() {
    store.commit("showLoader", false); // Loader Off
  },
};
</script>

